import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu13",
  "use": "icon-menu13-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 52 52\" id=\"icon-menu13\">\r\n<path fill=\"currentColor\" d=\"M45.557,11.048H23.83v-0.213c0-2.022-1.319-4.656-2.946-4.656H2.952C1.319,6.179,0,8.813,0,10.835v6.645v8.894v12.01\r\n\tc0,3.555,2.877,6.432,6.432,6.432h39.125c3.555,0,6.432-2.877,6.432-6.432V17.48C51.988,13.925,49.111,11.048,45.557,11.048z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol